export const SituacaoPropostaEnum = {
  ATUAL: 'atual',
  SIMULACAO: 'simulada'
}
